module.exports = __webpack_public_path__ + "static/img/icon-detail.5b2206d.png";